import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { madeHere } from '../../data/home';
import { SectionTag } from '../shared/SectionTag';
export function MadeHere() {
  return <section className="bg-coal py-20 md:py-32" aria-labelledby="made-heading" data-id="element-35" data-mp="21tz0zckdo446">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8" data-id="element-36" data-mp="25thq6kj8f1ct">
        <SectionTag data-id="element-37" data-mp="25rww0w0txkfh">What we make</SectionTag>
        <h2 id="made-heading" className="mt-5 max-w-3xl font-display text-[44px] font-bold uppercase leading-[0.9] text-chalk sm:text-5xl md:text-7xl" data-id="element-38" data-mp="2tkww0na7w0st">
          Made in Our Umm Al Quwain Plant
        </h2>

        <div className="mt-14 space-y-20 md:mt-16 md:space-y-28" data-id="element-39" data-mp="2kl9s9uu0miwl">
          {madeHere.map((item, index) => {
          const flipped = index % 2 === 1;
          return <article key={item.slug} className="grid items-center gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-40" data-mp="192fffm0b6dz0" data-mpi={index}>
                <div className={`relative lg:col-span-7 ${flipped ? 'lg:order-2' : ''}`} data-id="element-41" data-mp="1e4o6udxj97z0">
                  <div className={`absolute bottom-0 h-3/4 w-2/3 bg-flame ${flipped ? 'left-0' : 'right-0'}`} aria-hidden="true" data-id="element-42" data-mp="1v8ieee6bqanu" />
                  <Link to={`/products/${item.slug}`} className={`group relative block overflow-hidden ${flipped ? 'ml-5 mb-5 md:ml-8 md:mb-8' : 'mr-5 mb-5 md:mr-8 md:mb-8'}`} aria-label={`View ${item.linkLabel}`} data-id="element-43" data-mp="256xuzn7q61j3">
                    <img src={item.image} alt={item.alt} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.03]" data-id="element-44" data-mp="296q9egjsv1wd" />
                    <span className={`absolute top-0 bg-ink px-5 py-3 font-display text-lg font-bold uppercase tracking-[0.06em] text-flame ${flipped ? 'right-0' : 'left-0'}`} data-id="element-45" data-mp="2wy5dadr85r9q">
                      Manufactured in-house
                    </span>
                  </Link>
                </div>

                <div className="lg:col-span-5" data-id="element-46" data-mp="39wuxyx1a2of7">
                  <h3 className="font-display text-5xl font-bold uppercase leading-none text-chalk md:text-6xl" data-id="element-47" data-mp="39v1shl2eia8s">
                    {item.name}
                  </h3>
                  <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted" data-id="element-48" data-mp="3ion7n5ih9tiq">{item.description}</p>
                  <dl className="mt-8 border-l-[3px] border-flame" data-id="element-49" data-mp="3nmygbcx1dxzd">
                    <div className="pb-4 pl-5" data-id="element-50" data-mp="3sncqb0i77i01">
                      <dt className="text-sm font-bold uppercase tracking-[0.1em] text-flame" data-id="element-51" data-mp="3sljhpfo0ynpe">Variants</dt>
                      <dd className="mt-1.5 text-chalk" data-id="element-52" data-mp="1f8k5ti8452t">{item.variants}</dd>
                    </div>
                    <div className="pl-5" data-id="element-53" data-mp="1ybxzegdgbcip">
                      <dt className="text-sm font-bold uppercase tracking-[0.1em] text-flame" data-id="element-54" data-mp="237wjhrrqy8db">What to send us</dt>
                      <dd className="mt-1.5 text-chalk" data-id="element-55" data-mp="ked6ggd0l9x0">{item.sendUs}</dd>
                    </div>
                  </dl>
                  <Link to={`/products/${item.slug}`} className="mt-10 inline-flex h-14 items-center gap-2 whitespace-nowrap bg-flame px-8 font-bold uppercase tracking-[0.06em] text-ink transition-colors duration-150 hover:bg-chalk" data-id="element-56" data-mp="flk0xq9q1xjv">
                    {item.linkLabel}
                    <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-57" data-mp="zaufh0xqecge" />
                  </Link>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}